<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <b-tabs
        pills
        card
        active-tab-class="p-0"
        content-class="mt-3 pt-1 d-flex flex-column overflow-hidden"
        nav-wrapper-class="pt-0 pl-3"
        class="h-100 d-flex flex-column"
      >
        <b-tab :title="'Corporation' | i18n" active @click="selectedTab = 'Corporation'">
          <Corporation v-if="selectedTab === 'Corporation'" />
        </b-tab>
        <b-tab :title="'Company' | i18n" @click="selectedTab = 'Company'">
          <Company v-if="selectedTab === 'Company'" />
        </b-tab>
        <b-tab :title="'Operational Area' | i18n" @click="selectedTab = 'OperationalArea'">
          <OperationalArea v-if="selectedTab === 'OperationalArea'" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue';

import Corporation from './components/corporation';
import Company from './components/company';
import OperationalArea from './components/operational-area';

export default {
  name: 'CompanyStructure',
  components: { 'b-tabs': BTabs, 'b-tab': BTab, Corporation, Company, OperationalArea },
  data: function () {
    return {
      selectedTab: 'Corporation',
    };
  },
};
</script>

<style scoped lang="scss">
.main-content {
  overflow: scroll !important;
}
::v-deep .card-header {
  background: white;
}
::v-deep .nav-item a {
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>
